import $ from "jquery";
import { staffAuditReportFilters } from "./staffAuditReportFilters";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";
import { fileDownloader } from "../framework/fileDownloader";


function init() {
    setEvents();
}
function setEvents() {
    $("#btnApplyFilters").click(applyFilters);
    $("#btnDownloadExcel").click(downloadReport);
    $("#selectCourseType").change(function () {
        const courseTypeId = $("#selectCourseType").val();
        const programId = $("#programId").val();
        getCourseLengths(courseTypeId);
        getCourseEditions(courseTypeId, programId);
    });
}

function downloadReport() {
    const filters = staffAuditReportFilters.getFilters();
    let source = $(this).attr("href");

    if (!source.endsWith("?")) {
        source += "?";
    }

    fileDownloader.downloadFile(
        { url: source, data: filters, method: "POST" });
}

function applyFilters(isNewSearch) {
    forms.showSpinner();
    getData().then(function (data) {
        $("#indexStaffAuditResultsTableWrapper").html(data);
        $("#staffAuditReportSummaryTable").DataTable();
        $("#staffAuditReportUnHandledTable").DataTable();
        $("#staffAuditReportTable").DataTable();
        $("#staffApprovedByOthersReportTable").DataTable();
      forms.hideSpinner();
    });
}

function getData() {
    const filters = staffAuditReportFilters.getFilters();
    return dataaccess.post({ url: "/StaffAuditReport/getReport", data: filters });
}

function getCourseLengths(courseTypeId) {
    if (courseTypeId > 0) {
        dataaccess.get({ url: "/Course/GetCourseLengths/" + courseTypeId }).done(function (results) {
            $("#selectCourseLength option")
                .not(":first")
                .remove();
            let i;
            for (i = 0; i < results.length; i++) {
                $("#selectCourseLength").append(
                    "<option value=" +
                    results[i].id +
                    " data-schedule-days='" +
                    results[i].scheduleDays +
                    "'>" +
                    results[i].description +
                    "</option>"
                );
            }
        });
    }
}

function getCourseEditions(courseTypeId, programId) {
    if (courseTypeId > 0 && programId > 0) {
        dataaccess
            .get({
                url:
                    "/Course/GetCourseEditions/CourseType/" + courseTypeId + "/Program/" + programId
            })
            .done(function (results) {
                $("#selectCourseEdition option")
                    .not(":first")
                    .remove();
                let i;
                for (i = 0; i < results.length; i++) {
                    $("#selectCourseEdition").append(
                        "<option value=" +
                        results[i].id +
                        ">" +
                        results[i].description +
                        "</option>"
                    );
                }
            });
    }
}

export const staffAuditReport = {
    init: init
};